<template>
    <div class='component-page'>
        <!--文本搜索位置-->
        <div class="filter-area">
            <Row style='text-align: center;' class='add_search'>
                 <Col span="5">
                    <Input search v-model="formItem.realname" placeholder="输入教师" @on-search="handleSearch" style="width: 200px;" />
                </Col>
                <Col span="5">
                    <Input search v-model="formItem.name" placeholder="输入班级" @on-search="handleSearch" style="width: 200px;" />
                </Col>
               
                <Col span="2" style='float:right'>
                    <i-button icon="md-add" shape="circle" type="primary" @click="add_new">添加</i-button>
                </Col>
            </Row>
        </div>
        <div class="edittable-table-height-con">
            <Row class='search-select'>
               <Col span="8">
                    <span>时间：</span>
                    <Date-picker type="date" placeholder="选择日期" v-model='start_time' style="width: 130px;display:inline-block" @on-change='changStarttime'></Date-picker>
                    <span style="margin: 0 10px;">至</span>
                    <Date-picker type="date" placeholder="选择日期" v-model='end_time' style="width: 130px;display:inline-block" @on-change='changEndtime'></Date-picker>
                </Col>
            </Row>
            <Table stripe border :columns="editIncellColumns" :data="editIncellData"></Table>
            <div style="margin: 20px 0 10px 0 ;overflow: hidden;">
                <Page style='float: right' size="small" :total="total_count" :page-size="formItem.page_size" :current="formItem.page" @on-change="changePage" />
            </div>
        </div>
        <Modal v-model="addModel" width="520" :title="modelTitle">
            <div v-if='addModel'>
                <Form ref="formData" :model="formData" :rules="verificationRule" label-position="top">
                    <FormItem label="班级名称" prop='name'>
                        <Input v-model="formData.name" placeholder="请输入..."></Input>
                    </FormItem>
    
                    <FormItem label="上课时间" prop='study_week'>
                        <Select filterable v-model="formData.study_week" style='width:120px;' clearable>
                            <Option v-for="item in weekList" :value="item.id" :key="item.lesson_id">{{ item.id }}</Option>
                        </Select>
                        <span style="margin: 0 10px;"></span>
                        <TimePicker format="HH:mm" placeholder="选择时间" v-model="formData.study_time" style="width: 120px"></TimePicker>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button type='primary' shape="circle" ghost @click='cancel'>取消</Button>
                <Button type="primary" shape="circle" @click="save('formData')">确定</Button>
            </div>
        </Modal>
        <Modal v-model="assignTeacherModel" width="520" title="分配老师">
            <div v-if='assignTeacherModel'>
                <Form ref="assignTeacherForm" :model="assignTeacherForm" :rules="rechargeRule">
    
                    <FormItem label="老师" prop='teacher_id'>
                        <Select filterable v-model="assignTeacherForm.teacher_id" clearable>
                                <Option v-for="item in teacherList" :value="item.teacher_id" :key="item.teacher_id">{{ item.realname }}</Option>
                            </Select>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button type='primary' shape="circle" ghost @click='cancel'>取消</Button>
                <Button type="primary" shape="circle" @click="goAssignTeacher('assignTeacherForm')">确定</Button>
            </div>
        </Modal>
    
        <Modal v-model="classModel" width="720" title="分配课程">
            <Row class='search-select'>
                <Col span="2" style="">
                <i-button type="primary" icon="md-add" shape="circle" @click="addClass">添加</i-button>
                </Col>
            </Row>
            <Table stripe border :columns="classColumns" :data="classData"></Table>
        </Modal>
        <Modal v-model="addClassModel" width="720" title="添加课程">
            <div v-if='addClassModel'>
                <Form ref="rechargeForm" :model="classForm" :rules="classForm">
                    <FormItem label="课程" prop='lesson_id'>
                        <Select filterable v-model="classForm.lesson_id" clearable>
                            <Option v-for="item in classList" :value="item.lesson_id" :key="item.lesson_id">{{ item.name }}</Option>
                        </Select>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button type='primary' shape="circle" ghost @click='cancelDivide'>取消</Button>
                <Button type="primary" shape="circle" @click="divideInto('classForm')">确定</Button>
            </div>
        </Modal>
        <Modal v-model="remindModal" width="440" @on-cancel='cancel' class='remind'>
            <div class='remindContent'>
                {{remindContent}}
            </div>
            <div slot="footer">
                <Button type='primary' ghost shape="circle" @click='cancelRemind'>取消</Button>
                <Button type="primary" shape="circle" @click="primaryRemind">确定</Button>
            </div>
        </Modal>
    </div>
</template>

<style lang="css">
    @import "../common.css";
</style>

<script>
    import moment from 'moment'
    import {
        fetchTableList,
        fetchSchoolList,
        fetchTeacherList,
        fetchAssignTeacher,
        fetchClass,
        fetchClassList,
        fetchAssignClass,
        setDelete,
        fetchChapterList,
        setState,
        addModify,
        fetchInfo,
        setDel
    } from '@/api/classManagement'
    
    export default {
        name: 'user-components',
        data() {
            return {
                total_count: 0, //列表总条数
                formItem: {
                    page: 1, //列表当前页数
                    page_size: 10,
                    start_time: '',
                    end_time: '',
                    realname: '', 
                    name: '', 

                },
                start_time: '',
                end_time: '',
                modelTitle: '新增',
                class_id: '',
                class_lesson_id: '',
                classForm: {
                    class_id: '',
                    lesson_id: '',
                },
                formData: {
                    class_name: '',
                    school_id: '',
                    class_id: '',
                },
                teacherList: [], //老师下拉
                addModel: false, //添加用户
           
                school_id: '',
                classModel: false,
                addClassModel: false, //分班弹层
                weekList: [{
                        id: '周一'
                    },
                    {
                        id: '周二'
                    },
                    {
                        id: '周三'
                    },
                    {
                        id: '周四'
                    },
                    {
                        id: '周五'
                    },
                    {
                        id: '周六'
                    },
                    {
                        id: '周日'
                    },
                ],
                user_id: '', //用户id
                remindContent: '', //提醒内容
                remindModal: false, //提醒弹层状态
                assignTeacherModel: false, // 分配老师弹层状态
                assignTeacherForm: {
                    class_id: '',
                    teacher_id: '',
                }, // 充值数据
               
                verificationRule: {
                    name: [{
                        required: true,
                        message: '不能为空'
                    }],
                    study_week: [{
                        required: true,
                        message: '不能为空'
                    }],
                }, //
                // 状态列表
                statusList: [{
                    id: 1,
                    name: '正常'
                }, {
                    id: 0,
                    name: '禁用'
                }],
                schoolList: [],
                classList: [],
             
                classColumns: [{
                        title: '序号',
                        align: 'center',
                        type: 'index',
                    },
                    {
                        title: '课程',
                        align: 'center',
                        key: 'name',
                       
                    },
    
                    {
                        title: '操作',
                        align: 'center',
                        key: 'action',
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'error',
                                        size: 'small',
                                        ghost: true
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.deleteClass(params.row.class_lesson_id)
                                        }
                                    }
                                }, '删除'),
                            ])
                        },
                    }
                ],
                editIncellColumns: [{
                        title: '序号',
                        align: 'center',
                        type: 'index',
                        width: 80,
                    },
                    {
                        title: '班级名称',
                        align: 'center',
                        key: 'name',
    
                    },
                    {
                        title: '老师',
                        align: 'center',
                        key: 'realname',
                    },
                    {
                        title: '上课时间',
                        align: 'center',
                        key: 'week_time',
                        width:150,
                    },
                    {
                        title: '注册时间',
                        align: 'center',
                        key: 'create_time',
                        width:150,

                    },
                    {
                        title: '操作',
                        align: 'center',
                        key: 'action',
                        width: 280,
                        align: 'center',
                        render: (h, params) => {
    
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'info',
                                        size: 'small',
                                        ghost: true
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.edit(params.row.class_id)
                                        }
                                    }
                                }, '编辑'),
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small',
                                        ghost: true
    
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.assignTeacher(params.row.class_id, params.row.school_id)
                                        }
                                    }
                                }, '分配老师'),
    
    
                                h('Button', {
                                    props: {
                                        type: 'info',
                                        size: 'small',
                                        ghost: true
    
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.assignClass(params.row.class_id)
                                        }
                                    }
                                }, '分配课程'),
                                h('Button', {
                                    props: {
                                        type: 'error',
                                        size: 'small',
                                        ghost: true
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.delete(params.row.class_id)
                                        }
                                    }
                                }, '删除'),
                            ])
    
                        }
                    }
    
                ], //列表标题
                editIncellData: [], //列表数据
                classData: [], //课程列表数据
            };
        },
        methods: {
            //获取列表数据
            getData() {
                this.$Loading.start();
                fetchTableList(this.formItem).then(res => {
                    res = res.data;
                    this.$Loading.finish();
                    if (res.code == 200) {
                        this.editIncellData = res.data.list;
                        this.total_count = parseInt(res.data.total_count);
                    } else if (res.code == 14001) {
                        this.$Message.error(responese.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
            },
            getTeacherList() {
                fetchTeacherList().then(res => {
                    res = res.data;
                    if (res.code == 200) {
                        this.teacherList = res.data;
                    } else if (res.code == 14001) {
                        this.$Message.error(responese.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
            },
          
            getSchoolList() {
                fetchSchoolList().then(res => {
                    res = res.data;
                    if (res.code == 200) {
                        this.schoolList = res.data;
                    } else if (res.code == 14001) {
                        this.$Message.error(responese.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
            },
            getClassList() {
                fetchClassList().then(res => {
                    res = res.data;
                    if (res.code == 200) {
                        this.classList = res.data;
                        console.log(this.classList);
                    } else if (res.code == 14001) {
                        this.$Message.error(responese.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
            },
            // 添加用户
            add_new() {
                this.modelTitle = '新增';
                this.formData.class_id = '';
                this.formData.name = '';
                this.formData.study_week = '';
                this.formData.study_time = '';

                this.addModel = true;
            },
            edit(id) {
                fetchInfo({
                    class_id: id,
                }).then(res => {
                    res = res.data;
                    if (res.code == 200) {
                        this.modelTitle = '修改';
                        this.formData = res.data;
    
                        this.addModel = true;
                    } else if (res.code == 14001) {
                        this.$Message.error(res.msg)
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    } else {
                        this.$Message.error(res.msg)
                    }
                })
            },
            // 删除课程
            deleteClass(id) {
                this.class_lesson_id = id;
                this.remindContent = '确定删除该课程吗？';
                this.remindModal = true;
            },
            // 删除班级
            delete(id){
                this.class_id = id;
                this.remindContent = '确定删除该班级吗？';
                this.remindModal = true;
            },
            // 添加班级
            addClass() {
                this.classForm.lesson_id = '',
                this.addClassModel = true;
            },
            // 分配弹层显示
            assignClass(id) {
                this.class_id = id;
                fetchClass({
                    class_id: id
                }).then(res => {
                    res = res.data;
                    if (res.code == 200) {
                        if (res.data.length) {
                            this.classData = res.data;
                        } else {
                            this.classData = [];
                        }
                        this.classModel = true;
                    } else if (res.code == 14001) {
                        this.$Message.error(responese.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
            },
            // 分配课程
            divideInto() {
                fetchAssignClass({
                    class_id: this.class_id,
                    lesson_id: this.classForm.lesson_id,
                }).then(res => {
                    res = res.data;
                    if (res.code == 200) {
                        this.assignClass(this.class_id);
                        this.addClassModel = false;
                    } else if (res.code == 14001) {
                        this.$Message.error(responese.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
            },
            // 分配老师弹层展示
            assignTeacher(id, schoolId) {
                this.assignTeacherForm.class_id = id;
                this.assignTeacherForm.teacher_id = '';
                this.assignTeacherModel = true;
            },
            // 确认分配老师
            goAssignTeacher() {
                fetchAssignTeacher(this.assignTeacherForm).then(res => {
                    res = res.data;
                    if (res.code == 200) {
                        this.getData();
                        this.assignTeacherModel = false;
                    } else if (res.code == 14001) {
                        this.$Message.error(responese.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
            },
            // 保存
            save(name) {
                this.$refs[name].validate(valid => {
                    if (valid) {
                        addModify(this.formData).then(res => {
                            res = res.data;
                            if (res.code == 200) {
                                this.getData();
                                this.addModel = false;
                            } else if (res.code == 14001) {
                                this.$Message.error(res.msg)
                                this.$store.dispatch('handleLogOut').then(res => {
                                    this.$store.commit('clearOpenedSubmenu')
                                    this.$router.push({
                                        name: 'login'
                                    })
                                })
                            } else {
                                this.$Message.error(res.msg)
                            }
                        })
    
                    }
                })
            },
            //确定禁用或启用
            primaryRemind() {
                if(this.remindContent == '确定删除该班级吗？'){
                    setDel({
                        class_id: this.class_id
                    }).then(res => {
                        res = res.data;
                        if (res.code == 200) {
                            this.getData();
                            this.remindModal = false;
                        } else if (res.code == 14001) {
                            this.$Message.error(responese.msg);
                            this.$store.dispatch('handleLogOut').then(res => {
                                this.$store.commit('clearOpenedSubmenu')
                                this.$router.push({
                                    name: 'login'
                                })
                            })
                        } else {
                            this.$Message.error(res.msg);
                        }
                    })
                }else{
                    setDelete({
                        class_lesson_id: this.class_lesson_id
                    }).then(res => {
                        res = res.data;
                        if (res.code == 200) {
                            this.assignClass(this.class_id);
                            this.remindModal = false;
                        } else if (res.code == 14001) {
                            this.$Message.error(responese.msg);
                            this.$store.dispatch('handleLogOut').then(res => {
                                this.$store.commit('clearOpenedSubmenu')
                                this.$router.push({
                                    name: 'login'
                                })
                            })
                        } else {
                            this.$Message.error(res.msg);
                        }
                    })
                }
            },
            // 改变开始时间
            changStarttime(time) {
                if (time == '') {
                    this.formItem.start_time = '';
    
                } else {
                    this.formItem.start_time = new Date(time).getTime() / 1000 - 28800;
                }
                this.formItem.page = 1;
                this.getData();
            },
            // 改变结束时间
            changEndtime(time) {
                if (time == '') {
                    this.formItem.end_time = '';
    
                } else {
                    this.formItem.end_time = new Date(time).getTime() / 1000 + 57600;
                }
                this.formItem.page = 1;
                this.getData();
            },
            // 取消关闭弹层
            cancel() {
                this.assignTeacherModel = false;
                this.classModel = false;
                this.addModel = false;
            },
            cancelDivide() {
                this.addClassModel = false;
            },
            cancelRemind() {
                this.remindModal = false;
            },
            //搜索框搜索
            handleSearch() {
                this.formItem.page = 1;
                this.getData();
            },
            //改变当前页码
            changePage(row) {
                this.formItem.page = row;
                this.getData();
            },
    
        },
        created() {
            this.getData();
            this.getTeacherList();
            // this.getSchoolList();
            this.getClassList();
        }
    };
</script>
